import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() acceptButtonText: string = 'Aceptar';
  @Input() cancelButtonText: string = 'Cancelar';

  isVisible: boolean = false;

  private acceptAction?: () => void;
  private cancelAction?: () => void;

  openModal(title: string, message: string, acceptText = 'Aceptar', cancelText = 'Cancelar', acceptAction?: () => void, cancelAction?: () => void): void {
    this.title = title;
    this.message = message;
    this.acceptButtonText = acceptText;
    this.cancelButtonText = cancelText;
    this.acceptAction = acceptAction;
    this.cancelAction = cancelAction;
    this.isVisible = true;
  }

  closeModal(): void {
    this.isVisible = false;
  }

  accept(): void {
    if (this.acceptAction) {
      this.acceptAction();
    }
    this.closeModal();
  }

  cancel(): void {
    if (this.cancelAction) {
      this.cancelAction();
    }
    this.closeModal();
  }
}